import React, {createRef} from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage, {FORM_STATE_INIT_ERROR} from '../../components/plain/PlainPage';
import LabelField from '../../components/plain/LabelField';
import FieldString from '../../components/plain/FieldString';
import FieldInteger from '../../components/plain/FieldInteger';
import FieldDecimal from '../../components/plain/FieldDecimal';
import FieldDatetime from '../../components/plain/FieldDatetime';
import FieldEnum from '../../components/plain/FieldEnum';
import FieldRefList from '../../components/plain/FieldRefList';
import FieldList_TableGroup from '../../components/plain/FieldList_TableGroup';

import {getCurrentResource, formatDateTime, getDefinedValue} from '../../util/tools';
import {FORM_EBOOK_REPORT_PLAIN, FORM_EBOOK_SUPPLIER_TABLE, FORM_PRODUCT_TABLE} from '../../util/consts/forms';
import {EBOOK_SUPPLIER_PLAIN_PATH, PRODUCT_PLAIN_PATH} from '../../util/routes';
import {performApiRequest, ACTION_EBOOK_REPORT_GET_SUPPLIER_API_URL, ENTITY_LOAD_API_URL, 
ACTION_EBOOK_SUPPLIER_GET_FOR_REPORT_API_URL} from '../../util/restapi'; 
import {IET_ADD_LIST_ITEM, IET_SET_VALUE} from '../../util/realm/instance';
import {isSuperUser} from '../../util/localStorage';

import iconAdd from '../../assets/icons/png24x24/Add.png';
import iconClone from '../../assets/icons/png24x24/edit-multi.png';
import iconDelete from '../../assets/icons/png24x24/Delete.png';

class EBookReportGroupTablePlainPage extends PlainPage {

	resourceReportPage = null;
	refSupplierNodes = [
		{
			classId: 'EBookSupplier', plainFormPath: EBOOK_SUPPLIER_PLAIN_PATH, 
			selectInstanceFormId: FORM_EBOOK_SUPPLIER_TABLE,
			selectInstanceFormTitle: 'Розповсюджувач'
		}
	];
	
	readOnly = false;
	
	constructor(props) {
		super(props);
		this.plainId = FORM_EBOOK_REPORT_PLAIN + '_group';
		this.formPath = FORM_EBOOK_REPORT_PLAIN;
		this.formTitle = 'Звіт розповсюджувача за програмою "єКнига"';
		this.refQty = createRef();
		this.refAmount = createRef();
		this.resourceReportPage = getCurrentResource().pages.plain.EBookReportPlainPage;
	}
	componentDidMount = async () => {
		this.init('EBookReport')
		document.title = 'BOM. ' + this.formTitle;
	}
	completeInit = async () => {
		this.readOnly = this.instanceReadOnly;
		if( this.instance ) {
			let state = this.instance.rootField.value.state.value;
			if( state == 'accepted' && ! isSuperUser() )
				this.readOnly = true;
		}
		let beanSupplier = null;
		if( this.instance.id == null ) {
			this.instance.rootField.value.dateTime.value = formatDateTime( new Date() );
			let supplierRequest = {
				type: 'initial'
			}
			let response = await performApiRequest(ACTION_EBOOK_REPORT_GET_SUPPLIER_API_URL, supplierRequest);
			if( ! response.success ) {
				this.setState({formState: FORM_STATE_INIT_ERROR, message: response.message});
				return false;
			}
			beanSupplier = response.data;
			if( beanSupplier != null ) {
				let refSupplier = {
					id: beanSupplier.id,
					globalId: beanSupplier.globalId,
					className: beanSupplier.className,
					card: beanSupplier.cardMaster
				};
				this.instance.rootField.value.supplierRef.value = refSupplier;
			} 
		} else {
			let supplierRef = this.instance.rootField.value.supplierRef.value;
			if( supplierRef != null ) {
				let response = await performApiRequest(ACTION_EBOOK_SUPPLIER_GET_FOR_REPORT_API_URL, {supplierId: supplierRef.id});
				if( ! response.success ) {
					this.setState({formState: FORM_STATE_INIT_ERROR, message: response.message});
					return false;
				}
				beanSupplier = response.supplier;
			}
			this.recalculateSum();
		}
		this.recalculateSum();
		this.setState({supplier: beanSupplier, isSupplierRefReadOnly: this.instance.rootField.value.reportItem.value.length > 0})
		return true;
	}
	
	createItemCell = (columnId, rowIndex, instance, fieldGroup, plain) => {

		if( columnId == 'mid' ) {
			let enumerationMids = { id: 'mids', items: [] };
			let wrongValues = [];
			let supplier = plain.state.supplier;
			if( supplier != null ) {
				for(let m of supplier.merchantWithTerminals) {
					enumerationMids.items.push( {value: m.mid, label: m.mid} )
				}
			}
			if( ! instance.rootField.value.reportItem.value[rowIndex] ) {
				console.log( 'Empty mid', instance, rowIndex );
			}
			let mid = instance.rootField.value.reportItem.value[rowIndex].value.mid.value;
			if( mid ) {
				let valid = false;
				for( let e of enumerationMids.items) {
					if( e.value == mid ) {
						valid = true;
						break;
					}
				}
				if( ! valid ) {
					enumerationMids.items.unshift({value: mid, label: mid});
					wrongValues.push( mid );
				}
			}
			enumerationMids.items.unshift({value: '', label: ''})
			return (
				<FieldEnum instance={instance} path={'mid'} plain={plain} parentField={fieldGroup} 
					enumeration={enumerationMids} wrongValues={wrongValues} 
					styles={{ select: {width: '95%'}}}  ignoreTitle={true}/>
			);
		}
		if( columnId == 'tid' ) {
			let enumerationTids = { id: 'tids', items: [] };
			let wrongValues = [];
			let supplier = plain.state.supplier;
			if( supplier != null ) {
				let mid = instance.rootField.value.reportItem.value[rowIndex].value.mid.value;
				for(let m of supplier.merchantWithTerminals) {
					if( m.mid == mid ) {
						for(let t of m.terminalList ) {
							enumerationTids.items.push( {value: t.tid, label: t.tid} )
						}
					}
				}
			}
			let tid = instance.rootField.value.reportItem.value[rowIndex].value.tid.value;
			if( tid ) {
				let valid = false;
				for( let e of enumerationTids.items) {
					if( e.value == tid ) {
						valid = true;
						break;
					}
				}
				if( ! valid ) {
					enumerationTids.items.unshift({value: tid, label: tid});
					wrongValues.push( tid );
				}
			}
			enumerationTids.items.unshift({value: '', label: ''});
			return (
				<FieldEnum instance={instance} path={'tid'} plain={plain} parentField={fieldGroup} 
					enumeration={enumerationTids} wrongValues={wrongValues}
					styles={{ select: {width: '95%'}}}  ignoreTitle={true}
				/>
			);
		}
		return null;
	}
	
	handleInstanceChange = async (event) => {
		super.handleInstanceChange(event);
		let field = event.field;
		
		let fieldReportItem = this.instance.rootField.value.reportItem;
		if( event.eventType == IET_ADD_LIST_ITEM && field == fieldReportItem) {
			let index = event.index;
			let addedRow = fieldReportItem.value[index];
			if( ! addedRow.value.dateTime.value )
				addedRow.value.dateTime.value = this.instance.rootField.value.dateTime.value;
			addedRow.value.qty.value = '';
			addedRow.value.price.value = '';
		}
		
		let fieldRefSupplier = this.instance.rootField.value.supplierRef;
		let beanSupplier = null;
		if( event.eventType == IET_SET_VALUE && field == fieldRefSupplier ) {
			let supplierRef = fieldRefSupplier.value;
			if( supplierRef != null ) {
				let response = await performApiRequest(ENTITY_LOAD_API_URL, supplierRef);
				if( response.success ) {
					beanSupplier = response.data;
				}
			}
			this.setState({supplier: beanSupplier})
		}

		if( event.eventType == IET_SET_VALUE && field.model.fieldId == 'mid' ) {
			let supplier = beanSupplier;
			if( ! supplier )
				supplier = this.state.supplier;
			if( supplier != null ) {
				let mid = field.value;
				for(let m of supplier.merchantList) {
					if( m.mid == mid ) {
						if( m.terminals.length == 1 && ! field.parent.value.tid.value ) {
							let tid = m.terminals[0].tid;
							field.parent.value.tid.value = tid; 
						}
					}
				}
			}
		}
		
		this.setState({
			isSupplierRefReadOnly: this.instance.rootField.value.reportItem.value.length > 0,
			plainDirtyCounter: this.state.plainDirtyCounter + 1 
		});
		
		let recalcSum = false;
		while( field != null ) {
			if( field == fieldReportItem ) {
				recalcSum = true;
				break;
			} else {
				field = field.parent;
			}
		}
		if( recalcSum )
			this.recalculateSum();
	}
	recalculateSum = () => {
		let validSum = true;
		let sum = 0;
		let qtyTotal = 0;
		for(let item of this.instance.rootField.value.reportItem.value) {
			let itemQty = item.value.qty.value;
			let price = item.value.price.value;
			if( itemQty==null || price==null || Number(itemQty) == NaN || Number(price) == NaN) {
				validSum = false;
				break;
			}
			qtyTotal += Number(itemQty);
			sum += Number(price);
		}
		if( validSum ) {
			sum = Math.round(sum * 100) / 100
			this.instance.setFieldValue(this.instance.rootField.value.amount, sum);
			this.instance.setFieldValue(this.instance.rootField.value.qty, qtyTotal);
		} else {
			this.instance.setFieldValue(this.instance.rootField.value.qty, '');
			this.instance.setFieldValue(this.instance.rootField.value.amount, '');
		}
		if( this.refQty.current )
			this.refQty.current.setState({valueIsValid: validSum});
		if( this.refAmount.current )
			this.refAmount.current.setState({valueIsValid: validSum});
	}

	renderBody() {
		let instance = this.state.instance;
		let providerRef = null;
		let supplier = this.state.supplier;
		if( supplier ) {
			providerRef = supplier.providerRef;
		}
		console.log('supplier', supplier);
		
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					<div style={{display: 'flex', alignItems: 'center'}}>
						<FieldRefList instance={instance} path={'/supplierRef'} plain={this}
							readOnly={this.state.isSupplierRefReadOnly || this.readOnly}
							styles={{divMain: {flexGrow: '1', marginRight: '20px'}}}
						/>
					</div>
					{/*
					<div style={{display: 'flex', alignItems: 'center'}}>
						<FieldReference instance={instance} path={'/supplierRef'} plain={this}
							refNodes={this.refSupplierNodes}
							readOnly={this.state.isSupplierRefReadOnly || this.readOnly}
							styles={{divMain: {flexGrow: '1', marginRight: '20px'}}}
						/>
					</div>
					*/}
					<div style={{ display: 'flex', marginTop: '15px',alignItems: 'center'}}>
						<FieldDatetime instance={instance} path={'/dateTime'} plain={this} 
							readOnly={this.readOnly}
							styleInput={{width: '200px', marginRight: '20px'}} 
						/>
						<FieldEnum instance={instance} path={'/year'} plain={this} 
							readOnly={this.readOnly}
							styles={{ select: {flexGrow: '0', marginRight: '20px'}}}
						/>
						<FieldEnum instance={instance} path={'/month'} plain={this} 
							readOnly={this.readOnly}
							styles={{ select: {flexGrow: '0', marginRight: '20px'}}}
						/>
						<FieldInteger ref={this.refQty} instance={instance} path={'/qty'} plain={this} readOnly={true}
							readOnly={this.readOnly}
							styleInput={{width: '60px', textAlign: 'right', marginRight: '20px'}} 
						/>
						<FieldDecimal ref={this.refAmount} instance={instance} path={'/amount'} plain={this} readOnly={true}
							readOnly={this.readOnly}
							styleInput={{width: '100px', textAlign: 'right', marginRight: '20px'}} 
						/>
						<FieldEnum instance={instance} path={'/state'} plain={this} 
							readOnly={ ! isSuperUser() }
							styles={{ select: {flexGrow: '0'}}}
						/>
					</div>
					<div style={{marginTop: '20px'}}>
						<FieldList_TableGroup instance={instance} path={'/reportItem'}
							plain={this} plainDirtyCounter={this.state.plainDirtyCounter}
							readOnly={this.readOnly}
							header={ItemTableHeader} createDataCellComponent={this.createItemCell} 
							columnCard={{ 
								columnId: 'productRef',
								refNodes: [
									{
										classId: 'Product', plainFormPath: PRODUCT_PLAIN_PATH, 
										selectInstanceFormId: FORM_PRODUCT_TABLE,
										selectInstanceFormTitle: 'Продукт',
										filtersInitData: [{predicateId: 'provider', value: providerRef}]
									}
								]
							}}

							table={{
								columns: [
									{ columnId: 'dateTime', styles: {tdHeader: {width: '15%'} } }, 
									{ columnId: 'ps', styles: {tdHeader: {width: '10%'} } },
									{ columnId: 'aid', styles: {tdHeader: {width: '10%'} } },
									{ columnId: 'mid', styles: {tdHeader: {width: '10%'} } },
									{ columnId: 'mcc', styles: {tdHeader: {width: '7%'} } },
									{ columnId: 'tid', styles: {tdHeader: {width: '10%'} } },
									{ columnId: 'bin', styles: {tdHeader: {width: '12%'} } },
									{ columnId: 'operation', styles: {tdHeader: {width: '12%'} } },
									{ columnId: 'tranId', styles: {tdHeader: {width: '8%'} } },
									{ columnId: 'qty', styles: {tdHeader: {width: '2%'} } },  
									{ columnId: 'price', styles: {tdHeader: {width: '4%'}, dataComponent: { input: {width: '95%', textAlign: 'right'} } } },
								],
							}}
							styles={{
								table: {width: '100%'},
								trHeader: {height: '40px'}
							}}
						/>
					</div>
					<div style={{marginTop: '20px', paddingRight: '9px'}}>
						<div>
							<LabelField instance={instance} path={'/comment'} />
						</div>
						<div>
							<FieldString instance={this.state.instance} path={'/comment'} plain={this}
								multiline={true} rows={5} cols={60} styles={{input: {width: '100%'}}}
								readOnly={this.readOnly}
							 />
						</div>
					</div>			
				</div>
			</div>
		)
	}
}

class ItemTableHeader extends React.Component {

	/*
		table
		readOnly
	*/
	constructor(props) {
		super(props);
	}

	addItem = () => {
		let plain = this.props.table.props.plain;
		console.log('add item. State', plain.state);
		let supplier = plain.state.supplier;
		if( supplier == null ) {
			let resource = plain.resourceReportPage;
			plain.props.app.showMessage({mainMessage: resource.msgSelectSupplier});
			return;
		}

		let instance = this.props.table.props.instance;
		let fieldList = instance.rootField.value.reportItem;
		let newItem = instance.createInstanceField(fieldList.model.item, null);
		if( supplier.merchantList.length == 1 ) {
			let merch = supplier.merchantList[0]; 
			newItem.value.mid.value = merch.mid;
			if( merch.terminalList.length == 1 ) {
				newItem.value.tid.value = merch.terminalList[0].tid;
			}
		}
		instance.addListItem(fieldList, newItem, true);
	}
	addItemClone = () => {
		let plain = this.props.table.props.plain;
		let supplier = plain.state.supplier;
		if( supplier == null ) {
			let resource = plain.resourceReportPage;
			plain.props.app.showMessage({mainMessage: resource.msgSelectSupplier});
			return;
		}
		
		let index = this.props.table.state.selectedIndex;
		if( index < 0 )
			return;
		
		let instance = this.props.table.props.instance;
		let fieldList = instance.rootField.value.reportItem;
		let original = fieldList.value[index];
		let clone = instance.createInstanceField(fieldList.model.item, null);
		clone.value.dateTime.value = original.value.dateTime.value;
		clone.value.mid.value = original.value.mid.value;
		clone.value.tid.value = original.value.tid.value;
		clone.value.tranId.value = original.value.tranId.value;
		
		instance.addListItem(fieldList, clone, true);
	}

	render() {
		let readOnly = getDefinedValue(this.props.readOnly, false);
		let resource = this.props.table.props.plain.resourceReportPage;
		return(
			<div style={{marginBottom: '5px'}}>
				<button type='button' className={stylesPlain.buttonIcon}
					onClick={this.addItem} title={resource.buttonAdd}
					disabled={readOnly}
				>
					<img src={iconAdd} />
				</button>
				<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '5px'}}
					onClick={ this.addItemClone} title={resource.buttonClone}
					disabled={readOnly}
				>
					<img src={iconClone} />
				</button>
				<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '15px'}}
					onClick={this.props.table.deleteItem} disabled={readOnly}
				>
					<img src={iconDelete} />
				</button>
			</div>
		);
	}
}

export default EBookReportGroupTablePlainPage;
